import { useQuery } from "@tanstack/react-query"
import { Axios } from "../utils/Axios"

export const useUser = () => {
    return useQuery({
        queryKey: ['user'],
        queryFn: async () => {
            const user = await Axios.get('/auth/user');
            return user?.data?.data;
        }
    })
}
